<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ix"></a>
<h2 class="fm-title" id="list"><span class="bold">Plates</span></h2>
<p class="list">The swastika flag flying over Den Burg, Texel’s main town. <em class="italic">Aeronautical and War Museum Texel (LOMT)</em></p>
<p class="list">One of the German bunkers on the island. <em class="italic">Author</em></p>
<p class="list">Indian soldiers serving in the Wehrmacht. <em class="italic">(LOMT)</em></p>
<p class="list">The Hotel de Lindeboom, HQ of the German occupation forces. <em class="italic">LOMT</em></p>
<p class="list">A German soldier on Texel fraternising with local women. <em class="italic">LOMT</em></p>
<p class="list">German soldiers enjoying a beer. <em class="italic">LOMT</em></p>
<p class="list">A German soldier having a snooze on the peaceful island. <em class="italic">LOMT</em></p>
<p class="list">German personnel queuing for rations. <em class="italic">LOMT</em></p>
<p class="list">German troops playing games on Texel. <em class="italic">LOMT</em></p>
<p class="list">Members of the Georgian Legion. <em class="italic">LOMT</em></p>
<p class="list">Georgians of the 822nd Battalion relaxing. <em class="italic">LOMT</em></p>
<p class="list">Local Dutch Nazis. <em class="italic">LOMT</em></p>
<p class="list">Shalva Loladze, leader of the uprising. <em class="italic">Wikipedia</em></p>
<p class="list">Two wounded Georgian soldiers. <em class="italic">Wikipedia</em></p>
<p class="list">The bloodstained map used by Shalva Loladze. <em class="italic">Author</em></p>
<p class="list">The old lighthouse on Texel. <em class="italic">Author</em></p>
<p class="list">The Georgian Military Cemetery. <em class="italic">Author</em></p>
<p class="list">Poster for the Soviet film <em class="italic">Crucified Island</em>.</p>
<p class="list">Memorial for Cornelia Boon-Verberg. <em class="italic">Author</em></p>
<p class="list">The grave of Evgeni Artemidze. <em class="italic">Author</em></p>
<a id="page_x"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Listofplates.vue?b897565a